import { rtkQuery } from '~/services/rtkQuery';

import { GetMeResponse, LoginResponse, LoginVariables, RefreshTokenResponse } from './types';

export const userApi = rtkQuery.injectEndpoints({
  overrideExisting: true,
  endpoints: builder => ({
    login: builder.mutation<LoginResponse, LoginVariables>({
      query: ({ admin_page, ...data }) => ({
        url: 'oauth2/token',
        method: 'POST',
        body: data,
        params: { admin_page },
      }),
    }),
    refreshToken: builder.mutation<RefreshTokenResponse, void>({
      query: () => ({
        url: 'oauth2/token/refresh',
        method: 'POST',
      }),
    }),
    getMe: builder.query<GetMeResponse, void>({
      query: () => 'user/details',
    }),
  }),
});

export const { useLoginMutation, useGetMeQuery } = userApi;
